// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PQuonp1Q{display:flex}._7nKhGjg0{--padding-right:var(--spacing-md);min-width:0;width:100%}@media(max-width:1023.98px){._7nKhGjg0{--padding-right:0}}@media(max-width:1229.98px){.K4d-ASsk{padding:0 var(--spacing-md)}}@media(max-width:667.98px){.K4d-ASsk{padding:0 var(--spacing-sm)}}.QA10J\\+z4{color:var(--color-bg-invert);margin:0 auto var(--spacing-md);max-width:25rem;width:100%}@media(min-width:1023.98px){.QA10J\\+z4{display:none!important}}.NuA-hiKk{flex-basis:24.5rem;flex-grow:1;flex-shrink:0}.ffXU6IdD{display:flex;min-height:12.5rem}.c8tbQkFZ{min-height:25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "PQuonp1Q",
	"main": "_7nKhGjg0",
	"mainContent": "K4d-ASsk",
	"chatBtn": "QA10J+z4",
	"aside": "NuA-hiKk",
	"loading": "ffXU6IdD",
	"empty": "c8tbQkFZ"
};
module.exports = ___CSS_LOADER_EXPORT___;
